import { toast } from 'react-toastify'

export const alertActions = {
  success,
  error,
  info,
  clear,
  successUpdate,
  failUpdate,
  successDelete,
  failDelete,
}

/**
 *
 * @param {import('react-toastify').ToastContent<unknow>} message
 * @param {import('react-toastify').ToastOptions<unknow>} options
 */
function success(message, options) {
  toast.success(message, options)
}

/**
 *
 * @param {import('react-toastify').ToastContent<unknow>} message
 * @param {import('react-toastify').ToastOptions<unknow>} options
 */
function error(message, options) {
  toast.error(message, options)
}

/**
 *
 * @param {import('react-toastify').ToastContent<unknow>} message
 * @param {import('react-toastify').ToastOptions<unknow>} options
 */
function info(message, options) {
  toast.info(message, options)
}

function clear() {
  toast.dismiss()
}

function successUpdate() {
  return success('Cập nhật thành công')
}

function failUpdate() {
  return error('Cập nhật không thành công. Vui lòng thử lại sau ít phút')
}

function successDelete() {
  return success('Xóa thành công')
}

function failDelete() {
  return error('Xóa không thành công. Vui lòng thử lại sau ít phút')
}
